import { render, staticRenderFns } from "./EditEmailAddress.vue?vue&type=template&id=72c7cd90&scoped=true"
import script from "./EditEmailAddress.vue?vue&type=script&lang=js"
export * from "./EditEmailAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c7cd90",
  null
  
)

export default component.exports